import { ContentEditContainer } from 'modules/ContentEdit/containers';
import React from 'react'

type Props = {}

const ContentEdit = (props: Props) => {
  return (
    <ContentEditContainer />
  )
}

export default ContentEdit;